import type { FC } from "react";

import { PosMappingSearchForm } from "src/app/features/PosMapping/components/forms/PosMappingSearchForm";
import { PosMappingsTable } from "src/app/features/PosMapping/components/tables/PosMappingsTable";
import type { PosMappingEntity } from "src/app/features/PosMapping/types/PosMappingEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const PosMappingsPage: FC<NoneOwnProps> = () => {
    const table = <PosMappingsTable />;
    const searchForm = <PosMappingSearchForm />;
    const hasAccess = canAccess(ResourceName.POS_MAPPINGS, "canRead");

    return (
        <PageLayout name="posMappings_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.posMappings" />
                    <ResourceManager<PosMappingEntity>
                        useDataGroup={false}
                        dataMapperKey="posMappingsTableData"
                        resource={ResourceName.POS_MAPPINGS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
